import LocalizedClientLink from "@modules/common/components/localized-client-link"
import { ChevronRight } from "lucide-react"

export default function ViewAllLink({
  href,
  label = "View all",
  className = "",
}: {
  href: string
  label?: string
  className?: string
}) {
  return (
    <LocalizedClientLink
      href={href}
      className={`inline-flex items-center gap-2 text-sm font-medium text-brand-navy border border-brand-navy rounded-lg px-4 py-2 bg-white hover:bg-gray-50 transition-colors outline-none focus-visible:ring-2 focus-visible:ring-brand-navy focus-visible:ring-offset-2 ${className}`}
    >
      {label}
      <ChevronRight className="w-4 h-4" aria-hidden="true" />
    </LocalizedClientLink>
  )
}
